import {
  Table,
  Text,
  Switch,
  Menu,
  Badge,
  Stack,
  Divider,
  Title,
  Group,
  Button,
  Grid,
  Space,
  ActionIcon,
  UnstyledButton,
  ThemeIcon,
} from "@mantine/core";
import {
  TextInput,
  Textarea,
  Checkbox,
  Select,
  MultiSelect,
  NumberInput,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { showNotification } from "@mantine/notifications";

import {
  IconCircleCheck,
  IconPlus,
  IconCopy,
  IconCircleDashed,
  IconSearch,
  IconMessageCircle,
  IconSettings,
  IconPhoto,
  IconArrowsLeftRight,
  IconTrash,
  IconAdjustments,
} from "@tabler/icons";

import { roundDown } from "../hooks/useFomatter";
import { ENUM_FORM_DISPLAY, ENUM_FORM_LAYOUT_CONTAINER } from "./pageList";
import CommissionRelatedFields from "./commissionRelatedFields";
import CommissionVariation from "./commissionVariation";
import CommissionRateTable from "./commissionRateTable";
import moment from "moment";
import { useState, useEffect, useRef } from "react";
import { useFormRender } from "../hooks/useFormRender";
import { useDateRender } from "../hooks/useDateRender";

import ReactJson from "react-json-view";
import "dayjs/locale/zh-hk";

import _ from "lodash";
import { useFormatter } from "../hooks/useFomatter";
import { useServerApi } from "../hooks/userServerApi";
import { useAuthUser } from "react-auth-kit";
import { useTranslation } from "react-i18next";
import { CommissionScheduleProductCard } from "./commissionScheduleProductList";

const VersionViewer = ({
  rateFactor = 1,
  scheduleProductId,
  version,
  name,
  showGrossRateOnly = false,
}) => {
  return (
    <div>
      <CommissionScheduleProductCard
        scheduleProductId={scheduleProductId}
        version={version}
        showCode={false}
        showProductInfo={false}
        name={name}
        showGrossRateOnly={showGrossRateOnly}
        rateFactor={rateFactor}
      />
    </div>
  );
};

const ProductCommissionScheduleTable = ({
  form,
  name,
  disabled,
  rateFactor = 1, //0.525
  firstYearMaxPercentage, // for first year rate limit
  version = "COMPANY", //"CONSULTANT"
  showGrossRateOnly = false,
  ...props
}) => {
  const { t: translate } = useTranslation();
  const [api] = useServerApi();
  const id = form.values._id;
  const [scheduleProductList, setScheduleProductList] = useState([]);
  const [selected, setSelected] = useState(0);
  const auth = useAuthUser();

  const isSelected = (index) => index === selected;
  const isCurrentTable = (isSelectScheduleProduct) => {
    return true;
  };

  const VersionSelector = () => (
    <>
      {scheduleProductList.map((scheduleProduct, index) => (
        <UnstyledButton
          key={index}
          style={{ width: "100%" }}
          onClick={() => {
            setSelected(index);
          }}
        >
          <div
            key={index}
            style={{
              border: "1px solid",
              borderColor: isSelected(index) ? "lightgray" : "gray",
              padding: "10px",
              marginBottom: "20px",
              borderRadius: 10,
            }}
          >
            <Group position="apart">
              <Group spacing={6}>
                <Text size="sm" weight={800}>
                  {"V" + (scheduleProductList.length - index)}
                </Text>
                <Badge
                  size="xs"
                  radius={0}
                  color={scheduleProduct.professionalInvestor ? "orange" : "gray"}
                >
                  {scheduleProduct.professionalInvestor ? "PI" : "Non-PI"}
                </Badge>
              </Group>

              {isCurrentTable(index) && (
                <ThemeIcon color="teal" size={20} radius="xl">
                  <IconCircleCheck size={18} />
                </ThemeIcon>
              )}
            </Group>

            {/* <Group position="apart"> */}
            <Text color="dimmed" size="xs">
              {translate("Start : ")}
              {scheduleProduct.effectiveDate
                ? moment(scheduleProduct.effectiveDate).format("YYYY-MM-DD")
                : " ---"}
            </Text>

            <Text color="dimmed" size="xs">
              {translate("End : ")}
              {scheduleProduct.endDate
                ? moment(scheduleProduct.endDate).format("YYYY-MM-DD")
                : " ---"}
            </Text>
            {scheduleProduct.commissionSchedule?.code && (
              <Text color="dimmed" size={10} mt={4}>
                {scheduleProduct.commissionSchedule.code} &gt; {scheduleProduct.code}
              </Text>
            )}
          </div>
        </UnstyledButton>
      ))}
    </>
  );

  const fetchScheduleProductList = async () => {
    try {
      if (!id) return;
      const result = await api.Product.getCommissionScheduleProductList(id);
      //   console.log(result);
      setScheduleProductList(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchScheduleProductList();
  }, [id]);

  const [actualRateFactor, setActualRateFactor] = useState(0);

  const setActualRateByConsultant = async () => {
    console.log("setActualRateByConsultant", auth().id);
    if (!auth().id) return;

    //get producter rate by consultant
    const result = await api.User.getProducerRate(auth().id);
    console.log(result);
    if (!result || !result.rate) setActualRateFactor(0);
    setActualRateFactor(result.rate);
  };

  useEffect(() => {
    if (version === "COMPANY") {
      setActualRateFactor(1);
    } else {
      setActualRateByConsultant();
    }
  }, [version, auth().id]);

  return (
    <div>
      {/* <Group>Total Schedule: {scheduleProductList.length}</Group> */}
      {_.isEmpty(scheduleProductList) && (
        <Text size="sm" color="dimmed">
          No Commission Schedule Data
        </Text>
      )}
      {!_.isEmpty(scheduleProductList) && (
        <Grid grow gutter="xl">
          <Grid.Col span={10}>
            <VersionViewer
              rateFactor={actualRateFactor}
              scheduleProductId={scheduleProductList[selected]?._id}
              version={version}
              name={"V" + (scheduleProductList.length - selected)}
              showGrossRateOnly={showGrossRateOnly}
            />
          </Grid.Col>

          <Grid.Col span={2}>
            <VersionSelector scheduleProductList={scheduleProductList} />
          </Grid.Col>
        </Grid>
      )}
    </div>
  );
};

export default ProductCommissionScheduleTable;
